// 登录状态
let defaultIsLogin = false
    // 用户身份信息
let defaultUserInfo = {}
    // 地址
let groupAddress = ''
    // 结算需要的couponInfo
let shoppingCartCouponData = {}
    // 结算需要的productsInfo
let selectShoppingCartProducts = {}
    // 结算需要的orderNumInfo
let shoppingCartPreOrderInfo = {}
    // 优惠券页面的优惠券abacusCouponDTOList
let abacusCouponDTOList = []
    // pop店铺优惠券 shopCouponMap
let shopCouponMap = {}
    // 邀请人信息
let inviteInfo = {}
    // cdn参数
let CDNFormat = {
        scaledWidthLimitImage: '?imageView2/2/w/<width>/q/85',
        squaredImage: '?imageView2/5/w/<sideLength>/q/85'
    }
    // 页面可回退标识
let banBack = false

try {
    if (JSON.parse(localStorage.isLogin || false)) {
        defaultIsLogin = JSON.parse(localStorage.isLogin)
    }
    if (localStorage.userInfo) {
        defaultUserInfo = JSON.parse(localStorage.userInfo)
    }
    if (localStorage.inviteInfo) {
        inviteInfo = JSON.parse(sessionStorage.getItem('inviteInfo'))
    }
    if (localStorage.selectShoppingCartProducts) {
        selectShoppingCartProducts = JSON.parse(localStorage.selectShoppingCartProducts)
    }
    if (localStorage.shoppingCartPreOrderInfo) {
        shoppingCartPreOrderInfo = JSON.parse(localStorage.shoppingCartPreOrderInfo)
    }
    if (localStorage.abacusCouponDTOList) {
        abacusCouponDTOList = JSON.parse(localStorage.abacusCouponDTOList)
    }
    if (localStorage.shopCouponMap) {
        shopCouponMap = JSON.parse(localStorage.shopCouponMap)
    }
    if (localStorage.abacusCouponDTOList) {
        abacusCouponDTOList = JSON.parse(localStorage.abacusCouponDTOList)
    }
    if (localStorage.banBack) {
        banBack = localStorage.banBack
    }
} catch (error) {
    console.warn(error)
}

export default {
    isLogin: defaultIsLogin,
    userInfo: defaultUserInfo,
    groupAddress: groupAddress,
    shoppingCartPreOrderInfo: shoppingCartPreOrderInfo,
    selectShoppingCartProducts: selectShoppingCartProducts,
    shoppingCartCouponData: shoppingCartCouponData,
    abacusCouponDTOList: abacusCouponDTOList,
    shopCouponMap: shopCouponMap,
    inviteInfo: inviteInfo,
    CDNFormat: CDNFormat,
    banBack: banBack
}


// WEBPACK FOOTER //
// ./src/store/state.js